__turbopack_context__.v({
  "scroll": "ScrollingImage-module__cr1mcG__scroll",
  "wrapper": "ScrollingImage-module__cr1mcG__wrapper",
});
